<template>
  <div class="form-group input-box">
    <h3 class="step-name">{{ program.name }}</h3>
    <h5>{{ program.description }}</h5>
    <slot></slot>
    <template v-if="isReadOnly">
      <small class="subtext" v-html="conslutMarkerAction()"></small>
    </template>
    <template v-else>
      <small class="subtext">Currently {{ this.activeBefore ? '' : 'not' }} a member</small>
    </template>

    <radio-input :label="joinOrContinueLabel" :field-name="prefixedField('active_after', program.id, 'cm')"
      :add-email-notification="true" model-name="Programmes" :choices="choices" @on-change="handleJoinOrContinue"
      :disabled="isReadOnly">
    </radio-input>

    <div v-if="hasProgramOptions && activeAfter">
      <select-input :label="`${program.name} Programme`" :field-name="prefixedField('option_after', program.id, 'cm')"
        :disabled="isReadOnly" model-name="Programmes" required :options="programOptions" @on-change="handleOptionChange">
      </select-input>
    </div>
    <span class="form-group" v-if="showBookingNotes">
      <strong> {{ program.name }} Booking Notes </strong>
      <comments :field-name="getCommentfieldName" model-name="Programmes" @on-change="toggleNotification"></comments>
    </span>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { prefixedField } from '@/_helpers/utils'
import RadioInput from './RadioInput'
import SelectInput from './SelectInput'
import Comments from '@/components/Comments'

export default {
  name: 'ProgrammeInput',
  components: { RadioInput, SelectInput, Comments },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    programmeSlug: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions('currentConsult', ['setFieldValue']),
    ...mapMutations('currentConsult', ['setEmailNotification']),
    prefixedField: prefixedField,
    getMarkerDisplay: function (markerId) {
      return this.program.markers.find((m) => m.id == markerId).desc
    },
    conslutMarkerAction: function () {
      if (this.activeBefore) {
        if (this.activeAfter) {
          if (this.optionBefore != this.optionAfter) {
            return `Client changed from ${this.getMarkerDisplay(this.optionBefore)} to ${this.getMarkerDisplay(
              this.optionAfter
            )}`
          } else {
            return `Client continued without changes`
          }
        } else {
          return 'Client left the programme'
        }
      } else {
        if (this.activeAfter) {
          return `Client joined programme ${this.hasProgramOptions ? ` - ${this.getMarkerDisplay(this.optionAfter)}` : ''
            }`
        }
      }
      return ''
    },
    toggleNotification: function () {
      this.setEmailNotification({
        slug: this.isGFC ? 'gfc-markers-digest' : 'join-leave-all-wc-markers',
        value: this.shouldSendMarkersNotification,
      })
    },
    handleOptionChange: function ($event) {
      this.toggleNotification()
      this.$emit('on-change', $event)
    },
    handleJoinOrContinue: function ($event) {
      let value = $event.value
      this.toggleNotification()
      if (value) {
        this.setFieldValue({
          fieldName: prefixedField('option_after', this.program.id, 'cm'),
          modelName: 'Programmes',
          value: this.program.markers[0].id,
        })
      } else {
        this.setFieldValue({
          fieldName: prefixedField('option_after', this.program.id, 'cm'),
          modelName: 'Programmes',
          value: null,
        })
      }
      this.$emit('on-change', $event)
    },
  },
  computed: {
    ...mapGetters('currentConsult', [
      'getFieldValue',
      'getProgram',
      'isGFC',
      'isReadOnly',
      'hasModifiedProgrammes',
      'shouldSendMarkersNotification',
    ]),
    showBookingNotes: function () {
      return this.activeBefore != this.activeAfter || (this.activeBefore && this.activeAfter)
    },
    getCommentfieldName: function () {
      return `${this.program.slug.replaceAll('-', '_')}_booking_notes`
    },
    joinOrContinueLabel: function () {
      return this.activeBefore ? 'Continuing?' : 'Joining?'
    },
    choices: function () {
      return this.activeBefore
        ? [
          { display: 'Continue', value: true },
          { display: 'Leave', value: false },
        ]
        : [
          { display: 'Yes', value: true },
          { display: 'No', value: false },
        ]
    },
    program: function () {
      return this.getProgram(this.programmeSlug)
    },
    hasProgramOptions: function () {
      return this.program.markers.length > 1
    },
    programOptions: function () {
      return this.program.markers.map((marker) => {
        return { display: marker.desc, value: marker.id }
      })
    },
    optionBefore: function () {
      return this.getFieldValue(prefixedField('option_before', this.program.id, 'cm'), 'Programmes')
    },
    optionAfter: function () {
      return this.getFieldValue(prefixedField('option_after', this.program.id, 'cm'), 'Programmes')
    },
    activeBefore: function () {
      return this.getFieldValue(prefixedField('active_before', this.program.id, 'cm'), 'Programmes')
    },
    activeAfter: function () {
      return this.getFieldValue(prefixedField('active_after', this.program.id, 'cm'), 'Programmes')
    },
  },
}
</script>

<style>
.input-box {
  padding: 15px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
</style>
